/**
 * Created by ren on 17/07/2017.
 */
import * as apiCommon from '../../apiCommon';
import * as DocType from '../../../constants/constant_doc_types';
import * as ItemType from '../../../constants/constant_item_types';
import { setLineItemId } from '../helper_inventory';

export const saveInventoryTransfer = async (app, params) => {
  const { data, user = {} } = params;

  [
    '_id',
    'apply_status',
    'apply_to_location',
    'apply_to_location_id',
    'checkbox_inventory_status',
    'from_currency',
    'from_location',
    'from_subsidiary',
    'status',
    'isFetchingItemLocations'
  ].forEach(key => delete data[key]);

  data.lines.forEach(line => {
    [
      '_id',
      'item',
      'onEditMode',
      'process_line',
      'status',
      'next_status',
    ].forEach(key => delete line[key]);
    if (line.item_id) {
      line.item_id = line.item_id.split(':')[0];
    }
  });

  let inventoryTransfer = {
    id                         : data.id,
    doc_type                   : DocType.INVENTORY_TRANSFER,
    restart                    : data.restart,
    is_intercompany_transfer   : data.is_intercompany_transfer,
    sale_transaction_reference : data.sale_transaction_reference,
    brands                     : data.brand_ids && data.brand_ids.map(brand_id => ({ brand_id })),
    classifications            : data.classification_ids && data.classification_ids.map(classification_id => ({ classification_id })),
    alternate_classifications  : data.alternate_classification_ids && data.alternate_classification_ids.map(alternate_classification_id => ({ alternate_classification_id })),
    from_location_id           : data.from_location_id,
    from_location_type_id      : data.from_location_type_id,
    from_subsidiary_id         : data.from_subsidiary_id,
    from_currency_id           : data.from_currency_id,
    status_id                  : data.status_id,
    reason_code_id             : data.reason_code_id,
    lines                      : data.lines,
    comment                    : data.comment,
    custom_fields              : data.custom_fields,
  };

  const savedInventoryTransfer = await apiCommon.saveDoc(app, {
    source: data,
    doc: inventoryTransfer,
    user
  });

  setLineItemId(savedInventoryTransfer);
  return savedInventoryTransfer;
};

export const fetchInventoryTransferById = async( app, params ) => {
  const { id } = params;
  const result = await apiCommon.getDoc(
    app,
    { id, docType: DocType.INVENTORY_TRANSFER },
    { assemble_custom_fields: true }
  );
  setLineItemId(result);
  return result;
};

export const getItemLocation = async (app, locationId, subsidiaryId) => {
  const query = {
    location_id: locationId,
    subsidiary_id: subsidiaryId,
    item_types: [
      ItemType.INVENTORY,
      ItemType.BATCH,
      ItemType.SERIALIZED,
      ItemType.BUNDLE
    ],
    // fields: [
    //   'id',
    //   'item_id',
    //   'on_hand',
    //   'back_order_quantity',
    //   'in_transit',
    //   'item_type',
    //   'average_cost',
    //   'location_type',
    //   'currency_id',
    //   'location_id',
    //   'subsidiary_id',
    // ]
  };
  const result = await apiCommon.queryDocs(app, 'inventory_transfer/mass-transfer', query);

  return result;
};


export const getItemLocationById = async (app, params) => {
  const { itemId, locationId } = params;

  if (!locationId) {
    return null;
  }

  const service = apiCommon.getAccountService(app, DocType.ITEM_LOCATION);
  const query = {
    item: itemId,
    location: locationId
  };

  const { data } = await service.find({ query });

  return data[0];
};